<template>
  <ul>
    <component
      :is="resolveNavItemComponent(item)"
      v-for="item in items"
      :key="item.header || item.title"
      :item="item"
      v-if="conditionToShowNavMenu(item.name)"
    />
  </ul>
</template>

<script>
import { resolveVerticalNavMenuItemComponent as resolveNavItemComponent } from '@core/layouts/utils'
import { provide, ref } from '@vue/composition-api'
import VerticalNavMenuHeader from '../vertical-nav-menu-header'
import VerticalNavMenuLink from '../vertical-nav-menu-link/VerticalNavMenuLink.vue'
import VerticalNavMenuGroup from '../vertical-nav-menu-group/VerticalNavMenuGroup.vue'

export default {
  components: {
    VerticalNavMenuHeader,
    VerticalNavMenuLink,
    VerticalNavMenuGroup,
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
  setup() {
    provide('openGroups', ref([]))

    return {
      resolveNavItemComponent,
    }
  },
  methods: {
    conditionToShowNavMenu(_menuName) {
      switch (_menuName) {
        case 'sub-accounts':
        case 'my-invoices':
        case 'api-documentation':
          if (this.$store.state.userData.role !== 'ADMIN' || this.$store.state.userisloggued !== true) {
            return false;
          } else {
            return true;
          }
          break;
        case 'my-orders':
        case 'service-status':
        default:
          if (this.$store.state.userisloggued === true) {
            return true;
          } else {
            return false;
          }
          break;
      }
    }
  },
}
</script>
